"use client";

import { SiteHero, Ladder, SplitRow, FullBleedPhoto, FaqList, CtaBand, RelatedLinks } from "@/components/marketing/site-ui";
import { OpportunityMock } from "@/components/marketing/site-mocks";
import { useSiteContent } from "@/components/marketing/use-site-content";

export function OpportunitiesClient() {
  const c = useSiteContent();
  const page = c.opportunitiesPage;

  return (
    <>
      <SiteHero
        eyebrow={page.eyebrow}
        title={page.title}
        lede={page.lede}
        primaryLabel={page.primary}
        note={page.note}
        aside={<OpportunityMock />}
      />

      <section className="border-y border-neutral-200 bg-white py-14 md:py-20">
        <div className="gs-page">
          <Ladder steps={page.ladder} />
        </div>
      </section>

      <FullBleedPhoto
        src="/images/one-conversation.webp"
        srcSmall="/images/one-conversation-1400.webp"
        alt={page.photoAlt}
        eyebrow={page.photoEyebrow}
        title={page.photoTitle}
        body={page.photoBody}
      />

      <section className="py-16 md:py-24">
        <div className="gs-page">
          <SplitRow
            eyebrow={page.servicesEyebrow}
            title={page.servicesTitle}
            body={page.servicesBody}
            items={page.servicesItems}
            flip
            aside={
              /* The difference between the two things on this page, stated as a pair rather
                 than buried in a paragraph, because members mix them up constantly. */
              <div className="grid gap-3">
                {page.contrast.map((entry, index) => (
                  <div
                    key={entry.title}
                    className={
                      index === 0
                        ? "rounded-[1.5rem] border border-primary/25 bg-primary-lighter p-6 md:p-7"
                        : "rounded-[1.5rem] border border-neutral-200 bg-white p-6 md:p-7"
                    }
                  >
                    <p className="gs-eyebrow text-primary">{entry.label}</p>
                    <p className="mt-2.5 text-lg font-bold leading-snug tracking-[-0.02em] text-neutral-900">{entry.title}</p>
                    <p className="mt-2 text-[14.5px] leading-relaxed text-neutral-600">{entry.body}</p>
                  </div>
                ))}
              </div>
            }
          />
        </div>
      </section>

      <section className="border-t border-neutral-200 py-16 md:py-20">
        <div className="gs-page">
          {/* The measure goes on an inner box: .gs-page centres, so a narrower max-width on it
              would recentre this section and move the page's left edge. */}
          <div className="max-w-4xl">
            <FaqList heading={c.common.faqHeading} items={page.faq} />
          </div>
        </div>
      </section>

      <RelatedLinks
        links={[
          { href: "/features/discover", title: c.features.discover.name, body: c.features.discover.tagline },
          { href: "/for/business-owners", title: c.audiences.owners.name, body: c.audiences.owners.tagline },
          { href: "/pricing", title: c.nav.pricing, body: c.pricingPage.short },
        ]}
      />

      <div className="pt-14 md:pt-20">
        <CtaBand />
      </div>
    </>
  );
}
